import { useEffect, useState } from "react";
import { Check, Copy, Gift } from "lucide-react";
import { toast } from "sonner";
import { api, C, fmtChips } from "../lib/api";

const STATUS = { pending: ["text-slate-400", "pending"], ready: ["text-amber-300", "waiting (weekly cap)"], paid: ["text-emerald-300", "paid"] };

// Your referral code (immutable, derived from your tag) + who you've brought in and where they are on the 100-hand path.
export const ReferralBlock = () => {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get(C.ApiRoutes.MY_REFERRALS).then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(data.code); } catch { /* clipboard blocked: the code is still visible to select */ }
    setCopied(true); toast.success("Referral code copied"); setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div data-testid="referral-block" className="rounded-xl bg-black/30 border border-white/10 p-3 flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400 flex items-center gap-1.5"><Gift className="w-3.5 h-3.5 text-amber-400" /> Refer a friend</div>
        <span className="text-[10px] text-slate-500" data-testid="referral-week">{data.paid_this_week}/{data.weekly_max} paid this week</span>
      </div>
      <div className="flex items-center gap-2">
        <code data-testid="referral-code" className="flex-1 font-mono text-base tracking-[0.2em] text-amber-100 bg-black/40 rounded-lg px-3 py-1.5 select-all">{data.code}</code>
        <button data-testid="referral-copy" onClick={copy} className="btn-gold rounded-full px-3 py-1.5 text-xs font-display flex items-center gap-1 btn-lift">{copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy"}</button>
      </div>
      <p className="text-[11px] text-slate-400">Friends enter it when they sign up. Once they've played {data.hands_required} hands you get <span className="text-amber-200">{fmtChips(data.bonus)}</span> — up to {data.weekly_max} bonuses a week.</p>
      {data.referrals.length > 0 && (
        <ul className="flex flex-col gap-1 mt-1" data-testid="referral-list">
          {data.referrals.slice(0, 6).map((r) => (
            <li key={r.referral_id} className="flex items-center justify-between text-xs" data-testid="referral-row">
              <span className="text-slate-200 truncate">{r.referred_name}</span>
              <span className={`font-mono ${STATUS[r.status]?.[0] || "text-slate-400"}`}>{r.status === "pending" ? `${Math.min(r.hands, data.hands_required)}/${data.hands_required} hands` : STATUS[r.status]?.[1] || r.status}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
